export const ATTRIBUTE_NAME_TO_SHOW = {
    // Attribute of customer_infos
    "ci.age": {
        name: 'Tuổi', type: "2", "operators": [
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ],
    },
    "ci.birthday": {
        name: 'Ngày sinh dương lịch', type: "3", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ],
    },
    "ci.gender": {
        name: 'Giới tính', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ],
    },
    "ci.city": {
        name: 'Thành phố', type: "1", "dataType": 1,
        "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "ci.app_version": {
        name: 'Phiên bản', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ]
    },
    "ci.device_platform": {
        name: 'Phiên bản hệ điều hành', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "ci.os_platform": {
        name: 'Hệ điều hành', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "ci.device_name": {
        name: 'Tên thiết bị', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "ci.create_time": {
        name: 'Thời gian tạo customer id', type: "3", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ]
    },
    "ci.account_create_time": {
        name: 'Thời gian tạo tài khoản', type: "3", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ]
    },
    "ci.login_status": {
        name: 'Trạng thái đăng nhập', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "IN",
                "opSign": "in"
            }
        ]
    },
    "ci.login_type": {
        name: 'Hình thức đăng nhập', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "IN",
                "opSign": "in"
            }
        ]
    },
    "ci.allow_notification": {
        name: 'Cho phép bật thông báo', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            }
        ]
    },
    "ci.allow_location": {
        name: 'Cho phép bật vị trí', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            }
        ]
    },
    "ci.occupation": {
        name: 'Nghề nghiệp', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "ci.last_active_time": {
        name: 'Thời gian hoạt động gần nhất', type: "3", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ]
    },
    // Attribute of log_events
    "le.event_name": {
        name: 'Tên sự kiện', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    "le.screen_name": {
        name: 'Tên màn hình', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    // Attribute of log_ad_events
    // "lae.event_name": { name: 'lae.event_name', type: "" },
    // Attribute of premium
    // "p.start_time": { name: 'p.start_time', type: "" },
    "p.end_time": {
        name: 'Ngày hết hạn sử dụng', type: "3", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            },
            {
                "name": "Lớn hơn",
                "opSign": "gt"
            },
            {
                "name": "Nhỏ hơn",
                "opSign": "lt"
            },
            {
                "name": "Lớn hơn hoặc bằng",
                "opSign": "gte"
            },
            {
                "name": "Nhỏ hơn hoặc bằng",
                "opSign": "lte"
            },
            {
                "name": "Khoảng giá trị",
                "opSign": "between"
            }
        ]
    },
    "p.premium_groups": {
        name: 'Dịch vụ', type: "2", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "Khác",
                "opSign": "ne"
            },
            {
                "name": "IN",
                "opSign": "in"
            },
            {
                "name": "NOT IN",
                "opSign": "notIn"
            }
        ]
    },
    // Attribute of dùng dịch vụ
    "trang_thai_mua": {
        name: 'Trạng thái mua', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "IN",
                "opSign": "in"
            }
        ],
        "subAttributes": [
            {
                "name": "Dịch vụ",
                "identityName": "ddv.service"
            },
            {
                "name": "Số tháng trở lại đây được xét",
                "identityName": "ddv.duration"
            }
        ]
    },
    "muc_do_dung": {
        name: 'Tần suất sử dụng', type: "1", "operators": [
            {
                "name": "Bằng",
                "opSign": "eq"
            },
            {
                "name": "IN",
                "opSign": "in"
            }
        ], "subAttributes": [
            {
                "name": "Dịch vụ",
                "identityName": "ddv.service"
            },
            {
                "name": "Số tháng trở lại đây được xét",
                "identityName": "ddv.duration"
            },
            {
                "name": "Số lần/Tháng",
                "identityName": "ddv.perMonth"
            },
            {
                "name": "Số tháng tối thiểu",
                "identityName": "ddv.minMonths"
            }
        ]
    },
};